(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('quickActionsController', QuickActionsController);

  QuickActionsController.$inject = ['$rootScope',
    'brtSwitchCMS',
    'wirelessDashboardService',
    'uteModal'];

  function QuickActionsController($rootScope,
                                  brtSwitchCMS,
                                  wirelessDashboardService,
                                  uteModal) {
    var qaCtrl = this;
    init();

    function init() {
      qaCtrl.changeCallerId = wirelessDashboardService.openChangeCallerId;

      qaCtrl.isAccountHolder = !($rootScope.userInfo.profileType.subscriber);
      qaCtrl.isOwner = $rootScope.userInfo.profileType.owner;
      qaCtrl.isGroupId = $rootScope.userInfo.profileType.groupId;
      qaCtrl.showCallerId = brtSwitchCMS.brtSwitch.callerIdFlow;

    }

    qaCtrl.saleStatuspopup = function () {
      uteModal.open({
        templateUrl: 'modules/my-account/salestatus-modal.html',
        controller: ['$scope', '$modalInstance', '$translate', function ($scope, $modalInstance, $translate) {
          $scope.salereserve = $translate.instant('wireless.message.liveChat.salestatus.sale_reserve');
          $scope.backorder = $translate.instant('wireless.message.liveChat.salestatus.backorder-cta');
          $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
          };
        }]
      });
    };
  }

})();
